module.exports = __webpack_public_path__ + "static/media/ZTDC05.5ff200bc.jpg";